import {
  AMODULO_ADMAPPCLI,
  AMODULO_CRM,
  AMODULO_ESTOQUE,
  AMODULO_FINANCAS,
  AMODULO_FROTAS,
  AMODULO_GERENCIAL,
  AMODULO_PDVMOVEL,
  AMODULO_PARTNER,
  AMODULO_FRONT,
  ANAO,
  ASIM,
  DESC_NATIVE_MODULO_ADMAPPCLI,
  DESC_NATIVE_MODULO_CRM,
  DESC_NATIVE_MODULO_ESTOQUE,
  DESC_NATIVE_MODULO_FINANCAS,
  DESC_NATIVE_MODULO_FRONT,
  DESC_NATIVE_MODULO_FROTAS,
  DESC_NATIVE_MODULO_GERENCIAL,
  DESC_NATIVE_MODULO_PDVMOVEL,
  DESC_NATIVE_MODULO_PARTNER
} from 'consts';
import clsx from 'clsx';
import moment from 'moment';
import api from 'services/api';
import PropTypes from 'prop-types';
import validate from 'validate.js'; // ".js" realmente faz parte do nome da pasta
import i18n from 'translations/langEngine';
import { withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import { ComboEmpresa, ComboPDV } from 'views/Components';
import { CommonTranslations } from 'translations/translationKeys';
import { usePermissionContext } from 'contexts/PermissionContext';
import { saveConfigurations, saveCompany, savePDV } from 'lib/configUtils';
import { Button, Grid, Link, TextField, Typography, IconButton, InputAdornment } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';


/* Pega a URL da imagem do módulo */
const getBackgroundImage = (rota) => {
  if (rota === '/admappcli') return 'url(/images/authsisarepassenger.png)';
  if (rota === '/admpdvmovel') return 'url(/images/authpdvmovel.jpg)';
  if (rota === '/admpartner') return 'url(/images/authpartner.png)';
  if (rota === '/crm') return 'url(/images/authcrm.jpg)';
  if (rota === '/estoque') return 'url(/images/authestoque.jpg)';
  if (rota === '/financas') return 'url(/images/authfinancas.jpg)';
  if (rota === '/front') return 'url(/images/auth.jpg)';
  if (rota === '/frotas') return 'url(/images/authfrotas.jpg)';
  if (rota === '/gerencial') return 'url(/images/authgerencial.jpg)';
  if (rota === '/partner') return 'url(/images/authpartner.png)';

  return 'url(/images/authgerencial.jpg)';
};

const schema = {
  usuario: {
    presence: {
      allowEmpty: false,
      message: 'é obrigatório!'
    },
    length: {
      maximum: 20,
      message: 'deve ter no máximo 20 caracteres!'
    }
  },
  senha: {
    presence: {
      allowEmpty: false,
      message: 'é obrigatória!'
    }
  }
};

/* Estilos da tela de login geral (multi-módulo) */
const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
    height: '100%'
  },
  grid: { height: '100%' },
  quoteContainer: {
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  quote: {
    backgroundColor: theme.palette.neutral,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: getBackgroundImage(window.location.pathname),
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  },
  quoteInner: {
    textAlign: 'center',
    flexBasis: 600
  },
  quoteText: {
    color: theme.palette.black,
    fontWeight: 300,
  },
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  contentBody: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center'
    }
  },
  form: {
    paddingLeft: 100,
    paddingRight: 100,
    paddingBottom: 125,
    flexBasis: 700,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  title: { marginTop: theme.spacing(3) },
  textField: { marginTop: theme.spacing(2) },
  signInButton: { margin: theme.spacing(2, 0) },
  footer: {
    marginTop: theme.spacing(3),
    textAlign: 'center'
  }
}));

/* Tela de login geral */
const Login = props => {
  const { history, className } = props;
  const { refreshSession, clearAllPermissions } = usePermissionContext();
  const rotaModulo = history.location.pathname;

  let descModulo = '';
  let modulo = '';

  if (rotaModulo === '/financas') {
    descModulo = 'Finanças';
    modulo = AMODULO_FINANCAS;
  } else if (rotaModulo === '/front') {
    descModulo = 'Front';
    modulo = AMODULO_FRONT;
  } else if (rotaModulo === '/crm') {
    descModulo = 'CRM';
    modulo = AMODULO_CRM;
  } else if (rotaModulo === '/estoque') {
    descModulo = 'Estoque';
    modulo = AMODULO_ESTOQUE;
  } else if (rotaModulo === '/frotas') {
    descModulo = 'Frotas';
    modulo = AMODULO_FROTAS;
  } else if (rotaModulo === '/gerencial') {
    descModulo = 'Gerencial';
    modulo = AMODULO_GERENCIAL;
  } else if (rotaModulo === '/admappcli') {
    descModulo = 'AdmAppCli';
    modulo = AMODULO_ADMAPPCLI;
  } else if (rotaModulo === '/admpdvmovel') {
    descModulo = 'Adm PDV Móvel';
    modulo = AMODULO_PDVMOVEL;
  } else if (rotaModulo === '/admpartner') {
    descModulo = 'Partner';
    modulo = AMODULO_PARTNER;
  }

  const [configuracoes, setConfiguracoes] = useState({
    codEmpresa: 0,
    formaPDV: 0,
    traboOutraMoeda: 0,
  });

  const classes = useStyles();

  const [message, setMessage] = useState({
    message: ''
  });

  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {},
    rotaModulo,
    descModulo,
    modulo
  });

  const [translations, setTranslations] = useState({});
  const [mostrarSenha, setMostrarSenha] = useState(false);

  // limpa a sessão e as permissões sempre que o módulo de acesso muda
  useEffect(() => {
    sessionStorage.setItem('modulo', modulo);
    sessionStorage.removeItem('codUser');
    sessionStorage.removeItem('usuario');
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('lastLogin');
    sessionStorage.removeItem('isTechnicalUser');
    sessionStorage.removeItem('sisare_access_token');

    clearAllPermissions();
  }, [modulo, clearAllPermissions]);

  // revalida o formulário e recarrega as traduções
  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState(prev => ({
      ...prev,
      isValid: !errors,
      errors: errors || {}
    }));

    const termsNeeded = [
      CommonTranslations.LABEL_USER,
      CommonTranslations.LABEL_PASSWORD,
      CommonTranslations.LABEL_PDV
    ];

    i18n.fetchTerms(termsNeeded).then((trs) => {
      setTranslations(trs);
    }).catch((error) => {
      console.error('Erro ao carregar as traduções:', error);
    });
  }, [formState.values]);

  // atualiza os valores e marca os campos do formulário de login como tocados
  const handleChange = event => {
    event.persist();

    const { name, value } = event.target;
    const newValue = (name === 'usuario' || name === 'senha') ? value.toUpperCase() : value;

    setFormState(prev => ({
      ...prev,
      values: {
        ...prev.values,
        [name]: newValue
      },
      touched: {
        ...prev.touched,
        [name]: true
      }
    }));
  };

  // remove os dados de sessão do usuário e limpa as permissões carregadas
  function limparSessaoUsuario() {
    sessionStorage.removeItem('codUser');
    sessionStorage.removeItem('usuario');
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('lastLogin');
    sessionStorage.removeItem('isTechnicalUser');
    sessionStorage.removeItem('sisare_access_token');
    clearAllPermissions();
  };

  // retorna o nome do campo da empresa que indica se o módulo informado está habilitado
  function getCampoModuloEmpresa(moduloInformado) {
    switch (parseInt(moduloInformado, 10)) {
      case AMODULO_FRONT:
        return DESC_NATIVE_MODULO_FRONT;
      case AMODULO_FROTAS:
        return DESC_NATIVE_MODULO_FROTAS;
      case AMODULO_CRM:
        return DESC_NATIVE_MODULO_CRM;
      case AMODULO_ADMAPPCLI:
        return DESC_NATIVE_MODULO_ADMAPPCLI;
      case AMODULO_GERENCIAL:
        return DESC_NATIVE_MODULO_GERENCIAL;
      case AMODULO_PDVMOVEL:
        return DESC_NATIVE_MODULO_PDVMOVEL;
      case AMODULO_ESTOQUE:
        return DESC_NATIVE_MODULO_ESTOQUE;
      case AMODULO_FINANCAS:
        return DESC_NATIVE_MODULO_FINANCAS;
      case AMODULO_PARTNER:
        return DESC_NATIVE_MODULO_PARTNER;
      default:
        return null;
    }
  };

  // verifica se a empresa selecionada tem o módulo informado habilitado
  function empresaHabilitaModulo(empresa, moduloInformado) {
    if (!empresa) return false;

    const campoModulo = getCampoModuloEmpresa(moduloInformado);

    if (!campoModulo) {
      return true;
    }

    return String(empresa[campoModulo] || ANAO).toUpperCase() === ASIM;
  };

  // carrega e salva as configurações do módulo Front
  async function loadConfiguracoes() {
    let codEmpresa = sessionStorage.getItem('codEmpresa');

    if (!codEmpresa) codEmpresa = 1;

    return api.get(`/configuracoes/${codEmpresa}`, { timeout: 15000 }).then((response) => {
      setConfiguracoes({
        codEmpresa: response.data[0].codempresa,
        formaPDV: response.data[0].formapdv,
        traboOutraMoeda: response.data[0].traboutramoeda,
        fantasia: response.data[0].fantasia
      });

      sessionStorage.setItem('codEmpresa', response.data[0].codempresa);
      sessionStorage.setItem('trabOutraMoeda', response.data[0].traboutramoeda);
      sessionStorage.setItem('formaPDV', response.data[0].formapdv);
      sessionStorage.setItem('fantasia', response.data[0].fantasia);

      saveConfigurations(response.data[0], 'cfg');

      return response.data[0];
    }).catch((error) => {
      console.log(error);
      return null;
    });
  };

  // carrega e salva as configurações do módulo Finanças
  async function loadConfiguracoesFinancas() {
    let codEmpresa = sessionStorage.getItem('codEmpresa');

    if (!codEmpresa) codEmpresa = 1;

    return api.get(`/financas/configuracoes/${codEmpresa}`, { timeout: 15000 }).then((response) => {
      saveConfigurations(response.data[0], 'cfg_financas');
      return response.data[0];
    }).catch((error) => {
      console.log(error);
      return null;
    });
  };

  // carrega e salva as configurações do módulo CRM
  async function loadConfiguracoesCRM() {
    let codEmpresa = sessionStorage.getItem('codEmpresa');

    if (!codEmpresa) codEmpresa = 1;

    return api.get(`/crm/configuracoes/${codEmpresa}`, { timeout: 15000 }).then((response) => {
      saveConfigurations(response.data[0], 'cfg_crm');
      return response.data[0];
    }).catch((error) => {
      console.log(error);
      return null;
    });
  };

  // carrega os dados da empresa selecionada e, se as configurações se o CRM estiver habilitado
  async function loadEmpresa() {
    let codEmpresa = sessionStorage.getItem('codEmpresa');

    if (!codEmpresa) codEmpresa = 1;

    console.log('Vai carregar as empresas...');

    return api.get(`/empresa/${codEmpresa}`, { timeout: 15000 }).then((response) => {
      const empresa = response.data[0];

      saveCompany(empresa);

      if (String(empresa.modulocrm || ANAO).toUpperCase() === ASIM) {
        loadConfiguracoesCRM();
      }

      return empresa;
    }).catch((error) => {
      console.log(error);
      return null;
    });
  };

  // carrega e salva os dados do PDV selecionado
  async function loadPDV() {
    const codPDV = sessionStorage.getItem('codPDV');

    return api.get(`/pdv/${codPDV}`, { timeout: 15000 }).then((response) => {
      savePDV(response.data[0]);
      return response.data[0];
    }).catch((error) => {
      console.log(error);
      return null;
    });
  };

  // valida as credenciais do usuário na API e salva os dados da sessão
  async function validaUsuario() {
    try {
      const data = {
        usuario: formState.values.usuario,
        senha: formState.values.senha,
        codEmpresa: Number(sessionStorage.getItem('codEmpresa'))
      };

      const response = await api.post('/login', data, { timeout: 15000 });

      if (response.data.accessToken) {
        sessionStorage.setItem('sisare_access_token', response.data.accessToken);
      }

      // O nome retornado pela API para o usuário técnico pode ser 'Usuário Técnico'.
      // Por isso a identificação técnica deve considerar o login efetivamente digitado
      // (ADOISX), e não apenas o nome de exibição retornado pela API.
      const loginInformado = String(formState.values.usuario || '').trim().toUpperCase();
      const usuario = response.data.usuario || formState.values.usuario || '';
      const technicalFlagApi = String(response.data.isTechnicalUser || '').trim().toUpperCase();
      const isTechnicalUser =
        loginInformado === 'ADOISX' ||
        technicalFlagApi === ASIM ||
        technicalFlagApi === 'TRUE' ||
        response.data.isTechnicalUser === true;
      const lastLogin = moment(new Date()).format('DD/MM/YYYY');

      sessionStorage.setItem('codUser', response.data.codusuario);
      sessionStorage.setItem('usuario', usuario);
      sessionStorage.setItem('user', usuario);
      sessionStorage.setItem('lastLogin', lastLogin);
      sessionStorage.setItem('isTechnicalUser', isTechnicalUser ? ASIM : ANAO);
      sessionStorage.setItem('modulo', formState.modulo);

      setMessage({ message: 'Logando...' });

      return response;
    } catch (error) {
      if (error.message === 'Network Error') {
        setMessage({
          message: 'O serviço da API não respondeu!'
        });
      } else {
        setMessage({
          message: 'Login inválido!'
        });
      }

      return null;
    }
  };

  // redireciona o usuário para o dashboard do módulo correspondente
  const redirectToModule = () => {
    switch (parseInt(formState.modulo, 10)) {
      case AMODULO_GERENCIAL:
        history.push('/gerencial/dashboard');
        break;
      case AMODULO_FRONT:
        history.push('/front/dashboard');
        break;
      case AMODULO_FINANCAS:
        history.push('/financas/dashboard');
        break;
      case AMODULO_ADMAPPCLI:
        history.push('/admappcli/dashboard');
        break;
      case AMODULO_PDVMOVEL:
        history.push('/admpdvmovel/solicitacoes-pdv');
        break;
      case AMODULO_FROTAS:
        history.push('/frotas/dashboard');
        break;
      case AMODULO_CRM:
        history.push('/crm/dashboard');
        break;
      case AMODULO_ESTOQUE:
        history.push('/estoque/dashboard');
        break;
      case AMODULO_PARTNER:
        history.push('/admpartner/dashboard');
        break;
      default:
        break;
    }
  };

  // autentica, carrega os dados necessários e redireciona ao módulo
  const handleSignIn = async event => {
    event.preventDefault();

    if (!sessionStorage.getItem('codEmpresa')) {
      sessionStorage.setItem('codEmpresa', 1);
    }

    sessionStorage.setItem('moeda', 1);
    sessionStorage.setItem('mod-ger-tipoExtraFat', 3);

    const loginResponse = await validaUsuario();

    if (!loginResponse) {
      return;
    }

    clearAllPermissions();
    refreshSession();

    try {
      await Promise.all([
        loadConfiguracoes(),
        loadConfiguracoesFinancas()
      ]);

      const empresa = await loadEmpresa();

      if (!empresa) {
        limparSessaoUsuario();

        setMessage({
          message: 'Não foi possível carregar os dados da empresa!'
        });

        return;
      }

      if (!empresaHabilitaModulo(empresa, formState.modulo)) {
        limparSessaoUsuario();

        setMessage({
          message: 'Módulo não habilitado para a empresa selecionada!'
        });

        return;
      }

      if (formState.modulo !== AMODULO_FROTAS && formState.modulo !== AMODULO_PDVMOVEL && Number(sessionStorage.getItem('codPDV')) > 0) {
        await loadPDV();
      }
    } catch (error) {
      console.error('Erro ao carregar os dados pós-login:', error);

      limparSessaoUsuario();

      setMessage({
        message: 'Erro ao carregar os dados de login!'
      });

      return;
    }

    redirectToModule();
  };

  const hasError = field => !!(formState.touched[field] && formState.errors[field]);

  const lblUser = translations[CommonTranslations.LABEL_USER];
  const lblPassword = translations[CommonTranslations.LABEL_PASSWORD];

  return (
    <div className={classes.root}>
      <Grid
        className={classes.grid}
        container
      >
        <Grid
          className={classes.quoteContainer}
          item
          lg={5}
        >
          <div className={classes.quote}>
            <div className={classes.quoteInner}>
              <Typography
                className={classes.quoteText}
                variant="h1"
              ></Typography>
            </div>
          </div>
        </Grid>

        <Grid
          className={classes.content}
          item
          lg={7}
          xs={12}
        >
          <div className={classes.content}>
            <div className={classes.contentBody}>
              <form
                className={classes.form}
                onSubmit={handleSignIn}
              >
                <Typography
                  className={classes.title}
                  variant="h2"
                >
                  Login
                </Typography>

                <Typography
                  color="textSecondary"
                  gutterBottom
                >
                  {formState.descModulo}
                </Typography>

                <ComboEmpresa rotaModulo={formState.rotaModulo} />

                {formState.modulo !== AMODULO_FROTAS && formState.modulo !== AMODULO_PDVMOVEL && (
                  <ComboPDV rotaModulo={formState.rotaModulo} />
                )}

                <TextField
                  className={classes.textField}
                  error={hasError('usuario')}
                  fullWidth
                  helperText={hasError('usuario') ? formState.errors.usuario[0] : null}
                  inputProps={{ maxLength: 20 }}
                  label={lblUser || 'Usuário'}
                  name="usuario"
                  onChange={handleChange}
                  type="text"
                  value={formState.values.usuario || ''}
                  variant="outlined"
                />

                <TextField
                  className={classes.textField}
                  error={hasError('senha')}
                  fullWidth
                  helperText={hasError('senha') ? formState.errors.senha[0] : null}
                  inputProps={{ maxLength: 15 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label={mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'}
                          onClick={() => setMostrarSenha(prev => !prev)}
                          onMouseDown={event => event.preventDefault()}
                          edge="end"
                        >
                          {mostrarSenha ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  label={lblPassword || 'Senha'}
                  name="senha"
                  onChange={handleChange}
                  type={mostrarSenha ? "text" : "password"}
                  value={formState.values.senha || ''}
                  variant="outlined"
                />

                <Button
                  className={classes.signInButton}
                  color="primary"
                  disabled={!formState.isValid}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  Entrar
                </Button>

                <Typography id="servicoAPI">
                  {message.message}
                </Typography>

                <div className={clsx(classes.footer, className)}>
                  <Typography
                    color="textSecondary"
                    variant="body2"
                    align="center"
                  >
                    &copy;{' '}
                    <Link
                      component="a"
                      href="https://sisare.com.br"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      A2X Sistemas
                    </Link>
                    {' '}{new Date().getFullYear()}
                  </Typography>
                </div>
              </form>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

Login.propTypes = {
  history: PropTypes.object,
  className: PropTypes.string
};

export default withRouter(Login);